import type { ColumnDef } from "@tanstack/react-table";
import { Typography } from "@/core/components/ui/typography";
import type { PayrollStatementNotificationRecipient } from "@/payroll/pay-breakdown/payroll-statement-notifications/types";
import type { RecipientNoteColumnOptions } from "./types";

export const NoteCol = ({
  noteDrafts,
}: RecipientNoteColumnOptions): ColumnDef<
  PayrollStatementNotificationRecipient,
  unknown
> => ({
  id: "note",
  enableSorting: false,
  header: () => <span>Note</span>,
  cell: ({ row }) => {
    const note = (
      noteDrafts[row.original.technician_id] ??
      row.original.note ??
      ""
    ).trim();

    return note ? (
      <Typography
        variant="bodyW3"
        textColor="secondary"
        className="line-clamp-3 whitespace-pre-line"
      >
        {note}
      </Typography>
    ) : null;
  },
});
